import React from 'react';
import '../styles/AboutServicesSection.css';

// Example image imports (replace with your actual images)
import acbImg from '../assets/images/acb.jpg';
import vcbImg from '../assets/images/vcb.jpg';
import mccbImg from '../assets/images/mccb.jpg';
import retrofitImg from '../assets/images/retrofitting.jpg';
import ctptImg from '../assets/images/ctpt.jpg';
import switchgearImg from '../assets/images/switchgears.jpg';
import panelsImg from '../assets/images/LTHTPanels.jpg';
import relayImg from '../assets/images/LTHTProtectionRelay.jpg';

const services = [
  { title: 'Air Circuit Breaker (ACB)', img: acbImg },
  { title: 'Vacuum Circuit Breaker (VCB)', img: vcbImg },
  { title: 'Molded Case Circuit Breaker (MCCB )', img: mccbImg },
  { title: 'Retrofitting', img: retrofitImg },
  { title: 'CT & PT', img: ctptImg },
  { title: 'Switchgears & Spares', img: switchgearImg },
  { title: 'LT/HT Electrical Panels', img: panelsImg },
  { title: 'LT/HT Protection Relay', img: relayImg },
];

const AboutServicesSection = () => (
  <div className="services-container">

    <div className="services-header">
        <span className="services-header-icon">⚡</span>
        <span className="services-header-text">WHAT WE OFFER ?</span>
        <h1 className="services-title">Our Services</h1>
      </div>
    <div className="services-grid">
      {services.map((service, i) => (
        <div className="service-card" key={i}>
          <img src={service.img} alt={service.title} className="service-img" />
          <div className="service-title">{service.title}</div>
        </div>
      ))}
    </div>
  </div>
);

export default AboutServicesSection;
